import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { orderGridOpenMarkShippedModal } from '../../../store/orders/grid/orders.grid.header.actions';
import { BULK_MAS_PAGE, MARK_AS_SHIPPED_BULK_TRACKING_ID } from '../../../orders/mark-as-shipped/constants';
import { useContainsDemoOrder } from '../../../demos/hooks/use-contains-demo-order';
import { messages } from './messages';

export const useMarkShippedBulk = () => {
  const dispatch = useDispatch();
  const shouldBeDisabled = useContainsDemoOrder();
  const disabledReason = shouldBeDisabled ? messages.isDemoDisabledMessage : null;
  const actionHandler = useCallback(() => {
    dispatch(orderGridOpenMarkShippedModal(BULK_MAS_PAGE));
  }, [dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsMarkShippedBulk,
      pendoTrackingId: MARK_AS_SHIPPED_BULK_TRACKING_ID,
      isDisabled: shouldBeDisabled,
      disabledReason,
    };
  }, [actionHandler, disabledReason, shouldBeDisabled]);
};
